import { render, staticRenderFns } from "./PortadaV2.vue?vue&type=template&id=e5408aee&scoped=true&lang=pug&"
import script from "./PortadaV2.vue?vue&type=script&lang=js&"
export * from "./PortadaV2.vue?vue&type=script&lang=js&"
import style0 from "./PortadaV2.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./PortadaV2.vue?vue&type=style&index=1&id=e5408aee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5408aee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VApp,VAppBar,VCard,VCardText,VCol,VContainer,VFooter,VImg,VMain,VRow,VSheet})
